var _path, _path2, _path3, _ellipse, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStage1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 165,
    viewBox: "0 0 120 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.9397 0.000488281H100.004C102.179 0.000488281 103.943 1.76392 103.943 3.93917C103.943 4.6785 103.738 5.36903 103.383 5.9592C103.075 6.47135 103.423 7.12307 104.02 7.12307H109.792C111.928 7.12307 113.747 8.78387 113.823 10.918C113.903 13.1588 112.11 15.0002 109.887 15.0002H90.9264C88.7188 15.0002 86.8433 13.1936 86.8846 10.9864C86.8982 10.2661 87.1058 9.59413 87.4571 9.01898C87.7623 8.51913 87.3809 7.87764 86.7951 7.87764H80.9399C78.7647 7.87764 77.0012 6.1142 77.0012 3.93896C77.0012 1.76392 78.7644 0.000488281 80.9397 0.000488281Z",
    fill: "#DFF6FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9483 12.0597C96.7408 12.0597 94.8653 10.2531 94.9066 8.04592C94.9202 7.32556 95.1277 6.65361 95.479 6.07846C95.7842 5.57861 95.4029 4.93712 94.8171 4.93712H88.9619C86.7866 4.93712 85.0232 3.17368 85.0232 0.998439C85.0232 0.652761 85.0722 0.319392 85.1559 0H80.9387C78.7634 0 77 1.76343 77 3.93868C77 6.11392 78.7634 7.87735 80.9387 7.87735H86.7939C87.3797 7.87735 87.7611 8.51885 87.4559 9.01869C87.1048 9.59385 86.897 10.2658 86.8834 10.9862C86.8419 13.1933 88.7176 14.9999 90.9251 14.9999H109.886C111.716 14.9999 113.251 13.7509 113.694 12.0597H98.9483Z",
    fill: "#C8EFFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 165H120V141C120 127.745 109.255 117 96 117H24C10.7452 117 0 127.745 0 141V165Z",
    fill: "#81C784"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60,
    cy: 104.5,
    rx: 16,
    ry: 20.5,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1707 31.689H86.9846C88.9151 31.689 90.48 33.2539 90.48 35.1843V35.1978C90.4795 37.0132 89.0893 38.5261 87.2804 38.6797L76.8938 39.567L64.1707 31.689Z",
    fill: "#F9C795"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9436 37.0664L91.5011 39.5132C92.4193 39.6374 93.2498 40.1235 93.8078 40.8633C94.3658 41.603 94.605 42.5351 94.4721 43.4522V43.4656C94.2234 45.2628 92.6408 46.5709 90.8289 46.477L81.0997 45.9312L73.9436 37.0664Z",
    fill: "#F9C795"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4284 57.3261C91.3153 58.8125 89.2702 59.2388 87.6559 58.3209C87.6559 58.3209 73.0292 50.0531 66.5896 46.4098C64.8996 45.4643 62.8329 45.4951 61.1718 46.4905C60.8129 46.6895 60.4996 46.9489 57.9453 48.7759C56.5057 49.8059 55.9059 51.6543 56.4665 53.3333L58.5906 59.7056C59.1368 61.3506 58.4105 63.1489 56.8752 63.9533C55.34 64.7576 53.448 64.331 52.4065 62.9456L47.7281 56.6943C46.7126 55.3402 45.1187 54.5433 43.4261 54.5433C43.4261 54.5433 36.7043 54.5433 32.6712 51.8545L29.9824 31.689H64.1698C66.4022 31.6893 68.5613 32.4853 70.2598 33.9341L91.8638 52.2982C93.3534 53.5604 93.601 55.7649 92.4284 57.3261Z",
    fill: "#FDD7AD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9579 46.1137C64.392 45.4806 62.6197 45.62 61.172 46.4901L60.4326 46.0734C59.6249 45.6156 58.7125 45.3748 57.7842 45.3743H56.87C56.1275 45.3743 55.5256 44.7724 55.5256 44.0299C55.5256 43.2874 56.1275 42.6855 56.87 42.6855H57.7842C59.1789 42.6855 60.5499 43.0467 61.7635 43.7342L65.9579 46.1137Z",
    fill: "#F9C795"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9828 29H19.2278C17.7429 29 16.5391 30.2038 16.5391 31.6887V53.1987C16.5391 54.6836 17.7429 55.8874 19.2278 55.8874H29.9828C31.4677 55.8874 32.6715 54.6836 32.6715 53.1987V31.6887C32.6715 30.2038 31.4677 29 29.9828 29Z",
    fill: "#2EC3E9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6048 39.7549C26.0897 39.7549 27.2935 38.5511 27.2935 37.0662C27.2935 35.5812 26.0897 34.3774 24.6048 34.3774C23.1198 34.3774 21.916 35.5812 21.916 37.0662C21.916 38.5511 23.1198 39.7549 24.6048 39.7549Z",
    fill: "#ECF0F1"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7222 106.143C66.1962 106.143 71.4444 99.3951 71.4444 91.0714C71.4444 82.7477 66.1962 76 59.7222 76C53.2482 76 48 82.7477 48 91.0714C48 99.3951 53.2482 106.143 59.7222 106.143Z",
    fill: "#F09B73"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7227 92.746C59.2786 92.746 58.8526 92.5696 58.5386 92.2556C58.2245 91.9415 58.0481 91.5156 58.0481 91.0714V77.6746C58.0481 77.2305 58.2245 76.8045 58.5386 76.4905C58.8526 76.1764 59.2786 76 59.7227 76C60.1668 76 60.5928 76.1764 60.9068 76.4905C61.2209 76.8045 61.3973 77.2305 61.3973 77.6746V91.0714C61.3973 91.5156 61.2209 91.9415 60.9068 92.2556C60.5928 92.5696 60.1668 92.746 59.7227 92.746Z",
    fill: "#DB7F5F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6995 96.0953C55.6244 96.0953 56.3741 95.3456 56.3741 94.4207C56.3741 93.4958 55.6244 92.7461 54.6995 92.7461C53.7746 92.7461 53.0249 93.4958 53.0249 94.4207C53.0249 95.3456 53.7746 96.0953 54.6995 96.0953Z",
    fill: "#F2BBA5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M52.187 91.0712C53.5742 91.0712 54.6989 89.9466 54.6989 88.5593C54.6989 87.172 53.5742 86.0474 52.187 86.0474C50.7997 86.0474 49.675 87.172 49.675 88.5593C49.675 89.9466 50.7997 91.0712 52.187 91.0712Z",
    fill: "#F2BBA5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 131,
    width: 19,
    height: 6,
    rx: 3,
    fill: "#66BB6A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 142,
    width: 19,
    height: 6,
    rx: 3,
    fill: "#66BB6A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 134,
    width: 19,
    height: 6,
    rx: 3,
    fill: "#66BB6A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 148,
    width: 19,
    height: 6,
    rx: 3,
    fill: "#66BB6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStage1);
export default __webpack_public_path__ + "static/media/stage1.0decc513ce0b5a1f19c83c9539447907.svg";
export { ForwardRef as ReactComponent };